export const brands = [
  {
    id: 'luna-moon',
    name: 'LUNA MOON',
    description: 'Esmaltes semipermanentes de alta calidad y larga duración',
    productCount: 174,
    image: 'https://public.readdy.ai/ai/img_res/8a2c4c4407faa77a4c8e50862fa3488b.jpg'
  },
  {
    id: 'dnka',
    name: 'DNKa',
    description: 'Esmaltes semipermanentes de alta calidad y larga duración',
    productCount: 48,
    image: 'https://readdy.ai/api/search-image?query=Professional%20DNKa%20brand%20gel%20nail%20polish%20bottles%20collection%20arranged%20on%20elegant%20white%20surface%20with%20beauty%20tools%20and%20nail%20art%20samples%20modern%20cosmetic%20product%20photography%20clean%20aesthetic%20soft%20lighting&width=800&height=600&seq=dnka-brand&orientation=landscape'
  },
  {
    id: 'fox',
    name: 'F.O.X',
    description: 'Bases, tops y productos profesionales para manicura',
    productCount: 35,
    image: 'https://readdy.ai/api/search-image?query=FOX%20brand%20professional%20nail%20care%20products%20including%20base%20coat%20top%20coat%20and%20gel%20polish%20bottles%20displayed%20on%20modern%20white%20surface%20with%20nail%20art%20tools%20beauty%20salon%20photography%20clean%20minimalist%20aesthetic&width=800&height=600&seq=fox-brand&orientation=landscape'
  },
  {
    id: 'kodi',
    name: 'KODI Professional',
    description: 'Línea completa de productos profesionales para uñas',
    productCount: 62,
    image: 'https://readdy.ai/api/search-image?query=KODI%20Professional%20brand%20nail%20products%20collection%20with%20gel%20polish%20bottles%20nail%20care%20items%20and%20professional%20tools%20arranged%20elegantly%20on%20white%20marble%20surface%20beauty%20salon%20photography%20sophisticated%20lighting&width=800&height=600&seq=kodi-brand&orientation=landscape'
  },
  {
    id: 'oxxi',
    name: 'OXXI Professional',
    description: 'Gel polish y accesorios de calidad profesional',
    productCount: 41,
    image: 'https://readdy.ai/api/search-image?query=OXXI%20Professional%20brand%20gel%20nail%20polish%20collection%20with%20colorful%20bottles%20and%20professional%20nail%20accessories%20displayed%20on%20clean%20white%20surface%20modern%20beauty%20product%20photography%20elegant%20presentation&width=800&height=600&seq=oxxi-brand&orientation=landscape'
  },
  {
    id: 'tnl',
    name: 'TNL Professional',
    description: 'Productos innovadores para el cuidado de uñas',
    productCount: 38,
    image: 'https://readdy.ai/api/search-image?query=TNL%20Professional%20brand%20nail%20care%20products%20and%20gel%20polish%20bottles%20arranged%20professionally%20on%20white%20surface%20with%20beauty%20tools%20modern%20cosmetic%20photography%20clean%20aesthetic%20soft%20lighting&width=800&height=600&seq=tnl-brand&orientation=landscape'
  }
];
